import sample_1 from './sample_1.png';
import sample_2 from './sample_2.png';

export const dynamicBlazeChemReflect = {
    sample_1,
    sample_2
};
